// @TODO: combine with native
/*
 * Ryan O'Dowd
 * 2025-06-07
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  AppRegistry,
} from 'react-native';
import appJson from './app.json';
import index from './src/index/index.web';

AppRegistry.registerComponent(appJson.name, () => index);
AppRegistry.runApplication(appJson.name, {
  rootTag: document.getElementById('root'),
});
